import React from 'react';
import styled from '@emotion/styled';

import { TypographyText } from 'components/UI/atoms';
import { TableCell } from 'components/UI/atoms/table/TableCell';

const StyledTableCell = styled(TableCell)<{
  isSubItem?: boolean;
  isFirstInCategory?: boolean;
  isLastInCategory?: boolean;
  isMiddleInCategory?: boolean;
  categoryOmitFlag?: boolean;
  isLastSubCategory?: boolean;
}>`
  border-left: none !important;
  border-right: none;
  padding-left: ${(props) => (props.isSubItem ? '28px !important' : '8px')};
  padding-right: 0;
  height: 2.7rem;
  border-top: none;
  border-bottom: none;
  position: relative;

  ${(props) =>
    props.isSubItem &&
    `
    &::before {
      content: "";
      position: absolute;
      left: 12px;
      width: 2px;
      background-color: #a8a8a8;
      top: 0;
      ${
        props.isLastSubCategory
          ? props.isMiddleInCategory
            ? `height: 0%;`
            : props.isFirstInCategory || props.isLastInCategory
            ? `height: 50%;`
            : `height: 100%;`
          : `height: 100%;`
      }
    }
    
    ${
      !props.categoryOmitFlag
        ? `
      &::after {
        content: "";
        position: absolute;
        left: 12px;
        top: 50%;
        width: 12px;
        height: 2px;
        background-color: #a8a8a8;
      }
    `
        : ``
    }

    ${
      !props.categoryOmitFlag &&
      props.isLastSubCategory &&
      (props.isFirstInCategory || props.isMiddleInCategory)
        ? `
      &::before {
      top: 0;
      content: "";
      position: absolute;
      left: 12px;
      width: 2px;
      background-color: #a8a8a8;
      height: 50%;
    }
    `
        : ``
    }
    
    ${
      props.categoryOmitFlag &&
      props.isLastInCategory &&
      (props.isLastSubCategory || props.isMiddleInCategory)
        ? `
      &::before {
        content: "";
        position: absolute;
        left: 0px;
        top: 0%;
        width: 0px;
        height: 0px;
        background-color: none;
      }

      &::after {
        content: "";
        position: absolute;
        left: 0px;
        top: 0%;
        width: 0px;
        height: 0px;
        background-color: none;
      }
    `
        : ''
    }
    
  `}
`;

const CategoryTd = ({
  data,
  categoryOmitFlag,
  isSubItem,
  isFirstInCategory,
  isLastInCategory,
  isMiddleInCategory,
  isLastSubCategory,
}: {
  data: any;
  categoryOmitFlag: boolean;
  isSubItem?: boolean;
  isFirstInCategory?: boolean;
  isLastInCategory?: boolean;
  isMiddleInCategory?: boolean;
  isLastSubCategory?: boolean;
}) => {
  return (
    <StyledTableCell
      isSubItem={isSubItem}
      isFirstInCategory={isFirstInCategory}
      isLastInCategory={isLastInCategory}
      isMiddleInCategory={isMiddleInCategory}
      categoryOmitFlag={categoryOmitFlag}
      isLastSubCategory={isLastSubCategory}
    >
      {/* 디버그 용 */}
      {/* {`isSubItem: ${isSubItem}\n`} */}
      {/* {`categoryOmitFlag: ${categoryOmitFlag}\n`} */}
      {/* {`isFirstInCategory: ${isFirstInCategory}\n`} */}
      {/* {`isMiddleInCategory: ${isMiddleInCategory}\n`} */}
      {/* {`isLastInCategory: ${isLastInCategory}\n`} */}
      {/* {`isLastSubCategory: ${isLastSubCategory}\n`} */}
      {!categoryOmitFlag && (
        <TypographyText
          yjTypeTypographyText="symptom-table-body"
          fontWeight={isSubItem ? 400 : 700}
          letterSpacing={'-0.02rem'}
          whiteSpace={'pre-wrap'}
          wordBreak={'keep-all'}
        >
          {data?.label}
        </TypographyText>
      )}
    </StyledTableCell>
  );
};

export default React.memo(CategoryTd);
